export default __webpack_public_path__ + "static/media/collaborative.90fc3e88.svg";